import { Box, BoxProps, ColorOptions, Spacer, Text, TextInputProps, TextProps } from '@jfs/ui-new'
import { useEffect, useState, useTransition } from 'react'
import { getFormattedAmount } from '../../util/utill'
import { CurrencyInput } from '../CurrencyInput'

interface AmountInputProps {
  amount: any
  onAmountChange: any
  title: string
  precision?: number
  error?: string
  transactionType: 'cash_withdrawal' | 'cash_deposit' | 'fund_transfer'
}

const TNX_TYPE_DESC = {
  cash_withdrawal: 'withdrawal',
  cash_deposit: 'deposit',
  jpb_cash_deposit: 'JPB cash deposit',
  fund_transfer: 'fund transfer',
}

export const AmountInput = ({
  amount,
  onAmountChange,
  title,
  precision = 0,
  error,
  transactionType,
}: AmountInputProps) => {
  console.log('amount', amount)
  const MAX_INPUT_AMOUNT = JSON.parse(process.env.REACT_APP_MAX_INPUT_AMOUNT)?.[transactionType]
  const MAX_LIMIT_ERROR = process.env.REACT_APP_MAX_INPUT_AMOUNT_ERROR.replace(
    'TRANSACTION_TYPE',
    TNX_TYPE_DESC[transactionType],
  ).replace('MAX_AMOUNT', getFormattedAmount(MAX_INPUT_AMOUNT))
  const [amountInwords, setAmountInWords] = useState('')

  const [_, startTransition] = useTransition()
  const [showError, setShowError] = useState(false)
  const [showMaxLimit, setShowMaxLimit] = useState(false)
  useEffect(() => {
    startTransition(() => setAmountInWords(numberToWords(amount)))
  }, [amount])
  useEffect(() => {
    if (amount && +amount > MAX_INPUT_AMOUNT) {
      setShowMaxLimit(true)
      setTimeout(() => {
        setShowMaxLimit(false)
      }, 5000)
      onAmountChange('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transactionType])

  return (
    <Box {...styles.container}>
      <Text {...styles.titleStyle}>{title}</Text>
      <Spacer direction="vertical" size={8} />
      <Box ph={56} width={'100%'}>
        <CurrencyInput
          value={amount}
          showError={showError}
          onValueChange={(amount: any = 0) => {
            if (amount == '0') {
              amount = ''
            }
            if (+amount < MAX_INPUT_AMOUNT) {
              showError && setShowError(false)
              onAmountChange(amount)
            } else if (+amount === +MAX_INPUT_AMOUNT) {
              showError && setShowError(false)
              onAmountChange(+amount)
            } else if (+amount > MAX_INPUT_AMOUNT) {
              setShowMaxLimit(true)
              setTimeout(() => {
                setShowMaxLimit(false)
              }, 3000)
            } else if (!amount) {
              showError && setShowError(false)
              onAmountChange('')
            }
          }}
          prefix="₹ "
          decimalSeparator={'.'}
          allowDecimals={precision === 0 ? false : true}
          onBlur={() => {
            amount && amount < 10 && setShowError(true)
          }}
        />
        <>
          <Spacer size={8} />
          <Text {...styles.error}>{amountInwords}</Text>
        </>
        {error && (
          <>
            <Spacer size={8} />
            <Text {...styles.error}>{error}</Text>
          </>
        )}
        {!error && showError && amount && amount < 10 && (
          <>
            <Spacer size={8} />
            <Text {...styles.error}>**Minimum amount should be 10</Text>
          </>
        )}
        {!error && showMaxLimit && (
          <>
            <Spacer size={8} />
            <Text {...styles.error}>** {MAX_LIMIT_ERROR}</Text>
          </>
        )}
      </Box>
    </Box>
  )
}

const styles = {
  container: {
    pt: 16,
    pb: 24,
    backgroundColor: 'PRIMARY',
    alignItems: 'center',
  } as BoxProps,
  titleStyle: {
    fontSize: 12,
    fontFamily: 'jioType-medium',
    color: 'WHITE',
    opacity: 0.7,
  } as TextProps,
  amountTextInput: {
    fontSize: 46,
    color: 'WHITE',
    onFocusBottomLineColor: 'WHITE',
    lineHeight: 46 * 1.5,
    fontFamily: 'jioType-light',
    textAlign: 'center',
  } as TextInputProps,
  error: {
    fontSize: 12,
    color: '#FFFFFF' as ColorOptions,
    fontFamily: 'jioType-medium',
    textAlign: 'center',
  } as TextProps,
}

const numberToWords = (num) => {
  const ones = [
    '',
    'One',
    'Two',
    'Three',
    'Four',
    'Five',
    'Six',
    'Seven',
    'Eight',
    'Nine',
    'Ten',
    'Eleven',
    'Twelve',
    'Thirteen',
    'Fourteen',
    'Fifteen',
    'Sixteen',
    'Seventeen',
    'Eighteen',
    'Nineteen',
  ]

  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety']

  const thousands = ['', 'Thousand', 'Lakh', 'Crore', 'Arba', 'Kharab']

  if (num === 0) {
    return ''
  }

  let word = ''
  let chunk = 0

  // Process the number in chunks of 1000
  while (num > 0) {
    if (num % 1000 !== 0) {
      word = helper(num % 1000) + (thousands[chunk] ? ' ' + thousands[chunk] : '') + ' ' + word
    }
    num = Math.floor(num / 1000)
    chunk++
  }

  return word.trim() ? 'Rupees ' + word.trim() + ' Only' : ''

  function helper(num) {
    if (num === 0) {
      return ''
    }
    if (num < 20) {
      return ones[num]
    }
    if (num < 100) {
      return tens[Math.floor(num / 10)] + (num % 10 ? ' ' + ones[num % 10] : '')
    }
    return ones[Math.floor(num / 100)] + ' Hundred' + (num % 100 ? ' ' + helper(num % 100) : '')
  }
}
